import { ElementType, MouseEventHandler, ReactElement } from "react"
import cn from "classnames"
import { useToggle } from "react-use"
import type { PolymorphicPropsWithoutRef } from "react-polymorphic-types"

import { createPropsToClassNamesMapper, STYLE_PROPS } from "components/utils"
import style from "components/Collapsible/style.module.scss"
import { Text } from "ui-kit/components-branded/Text"

const styleMapper = createPropsToClassNamesMapper(STYLE_PROPS.SPACE.MARGIN)

interface ButtonProps {
    collapsed: boolean
    onClick: MouseEventHandler<HTMLButtonElement>
}

function DefaultButton({ onClick, collapsed }: ButtonProps) {
    return (
        <Text isAccent className={style.showMore} onClick={onClick}>
            {collapsed ? "Посмотреть все" : "Свернуть"}
        </Text>
    )
}

type defaultButton = typeof DefaultButton

interface OwnProps {
    collapsible?: boolean
    renderList(collapsed: boolean): ReactElement
    className?: string
}

type Props<T extends ElementType = defaultButton> = Omit<
    PolymorphicPropsWithoutRef<OwnProps, T>,
    "onClick" | "collapsed"
>

export function Collapsible<T extends ElementType = defaultButton>({
    renderList,
    collapsible = true,
    as,
    className,
    ...props
}: Props<T>) {
    const [collapsed, setCollapsed] = useToggle(collapsible)
    const Button: ElementType = as || DefaultButton
    return (
        <div className={cn(styleMapper(props), className)}>
            {renderList(collapsed)}
            {collapsible && <Button onClick={() => setCollapsed()} collapsed={collapsed} />}
        </div>
    )
}

Collapsible.DefaultButton = DefaultButton
